import Vue from 'vue'
import CripNotice from 'crip-vue-notice'
var numeral = require('numeral')
var moment = require('moment')
Vue.use(CripNotice)

Vue.mixin({
  methods: {
    dateFormat (date) {
      return moment(date).format('L')
    },
    monthFormat (str) {
      switch (str) {
        case '01':
          return 'ม.ค'
        case '02':
          return 'ก.พ'
        case '03':
          return 'มี.ค'
        case '04':
          return 'เม.ย'
        case '05':
          return 'พ.ค'
        case '06':
          return 'มิ.ย'
        case '07':
          return 'ก.ค'
        case '08':
          return 'ส.ค'
        case '09':
          return 'ก.ย'
        case '10':
          return 'ต.ค'
        case '11':
          return 'พ.ย'
        default:
          return 'ธ.ค'
      }
    },
    monthYearFormat (str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0]
        case '02':
          return 'กุมภาพันธ์ ' + date[0]
        case '03':
          return 'มีนาคม ' + date[0]
        case '04':
          return 'เมษายน ' + date[0]
        case '05':
          return 'พฤษภาคม ' + date[0]
        case '06':
          return 'มิถุนายน ' + date[0]
        case '07':
          return 'กรกฎาคม ' + date[0]
        case '08':
          return 'สิงหาคม ' + date[0]
        case '09':
          return 'กันยายน ' + date[0]
        case '10':
          return 'ตุลาคม ' + date[0]
        case '11':
          return 'พฤศจิกายน ' + date[0]
        default:
          return 'ธันวาคม ' + date[0]
      }
    },
    numberFormat (str) {
      return numeral(str).format('0,0')
    },
    checkPermission () {
      const menus = JSON.parse(sessionStorage.Data).permission
      const permiss = menus.findIndex(obj => obj.menu_link === this.$route.name)
      return permiss
    },
    alert_msg (type, title, text) {
      // $.toastr('add', {
      //   title: title,
      //   msg: text,
      //   clickClose: true,
      //   timeout: 3000,
      //   position: 'toast-top-right',
      //   type: type
      // })
      this.$notice[type]({
        title: title,
        description: text
      })
    },
    convert_vs (val) {
      var data = []
      var len = 3
      if (val.length > 3) {
        len = val.length
      }
      var vallen = val.length
      for (var i = 0; i < len; i++) {
        var v = val.split('')
        if (len - i === vallen) {
          var ss = len - i
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val)
            } else {
              if (len > val.length) {
                data.push(v[i - 1])
              } else {
                data.push(v[i])
              }
            }
          } else {
            data.push(v[i - 1])
          }
          vallen--
        } else {
          data.push('0')
        }
      }
      var versions = ''
      for (var l = 0; l < data.length; l++) {
        versions += data[l]
        if (l < data.length - 1) {
          versions += '.'
        }
      }
      return versions
    }
  }
})



// WEBPACK FOOTER //
// ./src/service/mixin.js